module.exports = __webpack_public_path__ + "static/media/NoDataErrorImage.fe36a77e.png";